<template>
  <div>
    <custom-dialog
      :visible="$route.params.form == 'AddEditForm'"
      :editMode="editMode"
      title="Storage"
      :closeDisabled="closeDisabled"
      :awaitingResponse="awaitingResponse"
      @close="$emit('close')"
      @submit="submitHandle"
    >
      <v-row justify="start" class="mt-2">
        <v-col cols="6">
          <v-text-field
            v-model="newStorage.name"
            class="mr-1"
            label="Storage Name"
            outlined
          />
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="newStorage.restaurantIds"
            :items="restaurants"
            item-text="name"
            item-value="id"
            multiple
            outlined
            label="Select Restaurants"
          />
        </v-col>
      </v-row>
      <v-row justify="start" class="mt-2">
        <v-col cols="12">
          <v-textarea
            v-model="newStorage.location"
            label="Storage Location"
            outlined
          />
        </v-col>
      </v-row>
    </custom-dialog>
  </div>
</template>

<script>
import CustomDialog from "../../shared/dialogs/FormDialog.vue"
import { mapState } from "vuex"

export default {
  name: "add-edit-form",
  components: {
    CustomDialog,
  },
  props: {
    visible: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      newStorage: {
        name: "",
        restaurantIds: [],
        location: "",
      },
      closeDisabled: false,
      awaitingResponse: false,
    }
  },
  computed: {
    ...mapState(["restaurants", "itemToEdit"]),
    editMode() {
      return this.itemToEdit != null
    },
  },
  watch: {
    "$route.params.form": {
      handler(newValue) {
        if (newValue == "AddEditForm") {
          if (this.editMode) {
            this.prepEdit()
          }
        } else {
          this.clearFields()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async submitHandle() {
      this.closeDisabled = this.awaitingResponse = true
      await this.$store.dispatch("updateStorages", this.newStorage).then(() => {
        this.closeDisabled = this.awaitingResponse = false
        if (this.$route.params.form != null) {
          this.$router.push({ params: { form: null, id: null } })
        }
      })
      this.$emit("close")
    },
    clearFields() {
      this.newStorage = {}
    },
    prepEdit() {
      Object.assign(this.newStorage, this.itemToEdit)
    },
  },
}
</script>
